import classNames from "classnames";
import { Typography } from "PFComponents/typography";

import css from "./count_tag.module.scss";

export type CountTagProps = {
  count: number;
  className?: string;
  variant?: "default" | "danger";
  highlight?: boolean;
};

export const CountTag = ({ count, variant = "default", highlight = false, className }: CountTagProps) => (
  <Typography
    withMargin
    variant="labelButton"
    className={classNames(css.tag, css[variant], { [css.highlight]: highlight }, className)}
  >
    {count}
  </Typography>
);
